import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { forgotPassword } from "../../../services/authService";
import IconButton from "../../common/Button";
import TextField from "../../common/TextField";
import ChipStatus from "../../common/ChipStatus";
import Spacer from "../../common/Spacer";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  // const { handleLogin, error } = useAuth();
  const navigate = useNavigate();

  const handleBackToLogin = () => {
    navigate("/login", { replace: true });
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccessMessage("");
    try {
      await forgotPassword(email);
      setError("");
      setSuccessMessage("A password reset link has been sent to this email");
      // Handle success
      // alert(data);
    } catch (error) {
      setSuccessMessage("");
      // Handle the error
      setError(
        error.response?.data?.error || "An error occurred. Please try again."
      );
    }
  };

  return (
    <form className="login-form" onSubmit={onSubmit}>
      <div className="login-title h4-bold">Forgot password</div>
      <Spacer />
      <p>
        Please enter and submit your email to receive a link to reset your
        password.
      </p>
      <div className="login-form-fields">
        <div className="form-group">
          <label htmlFor="email" className="field-label">
            Email
          </label>
          <TextField
            type="email"
            id="email"
            name="email"
            placeholder="Enter your email"
            value={email}
            onChange={(e) => {
              setEmail(e.target.value);
              setError("");
              setSuccessMessage("");
            }}
            required
            category="default" // You can change this to 'focused', 'error', or 'success' as needed
          />
        </div>
      </div>
      {/* Use the Button component as the submit button */}
      <IconButton
        variant="primary"
        state="idle"
        icon=""
        type="submit"
        width="376px"
      >
        Reset my password
      </IconButton>
      <Spacer height="25px" />
      <IconButton
        variant="ghost"
        state="idle"
        icon=""
        type="button"
        width="376px"
        onClick={handleBackToLogin}
      >
        Back to login
      </IconButton>
      {/* Display error if any */}
      {error && (
        <ChipStatus status="danger" autoDismiss={false}>
          {error}
        </ChipStatus>
      )}
      {/* Display success message if any */}
      {successMessage && (
        <ChipStatus status="success" autoDismiss={false}>
          {successMessage}
        </ChipStatus>
      )}
    </form>
  );
};

export default ForgotPassword;
